

















































































































































import {
  defineComponent,
  ref,
  defineAsyncComponent,
  onMounted,
  onActivated,
  onBeforeUnmount,
  computed,
  nextTick,
  watch,
} from '@vue/composition-api';
import { Popup, Button, Toast } from '@hb/coffee';
import type { RepayDialogDataType } from '@/components/finance-replan/types';
import type { CouponRolePo } from '@/api/coupon/types';
import { RouterV2Enum } from '@/router/router-names';
import router from '@/router';
import { FormInfomation } from '@/views_v2/card-list/types';
import { CloseOutline } from '@hb/coffee-icons';
import {
  openThirdPage, setNativeNavBar,
} from '@/api/native/utils';
import { skNativeContainer } from '@/api/native/container';
import { financeH5WebUrl } from '@/constant';
import platform from '@/shared/utils/platform';
import store from '@/store';
// 直接使用 FinanceBusiness mixin 中的方法
import FinanceBusiness from '@/mixins/finance-business';
import { supplyNeedConfig } from '@/api/userPersonalInfo';
import jumpToVerifyCredit from '@/shared/verify-credit-controller';
import { SceneTypeEnum } from '@/enums/scene-type';
import { VerifySceneEnum, OpenVerifyPageMode } from '@/shared/verify-credit-controller/types';
import { loanOrderCheck } from '@/api/apply-product';
import {
  RouteMarketEnum,
} from '@/api/apply-product/types';
import { ResponseCodeEnum } from '@/enums/response-code';
import { ubtSendError } from '@/shared/utils/ubt';
import { listerBack } from '@/shared/utils/backListener';
import { CreditDataType } from '@/api/homeV2Status/types';
import { reportQuickPopShow } from '@/api/quick-withdraw';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import PopupView from '@/components/popup-view';
import { popPageManager } from '@/shared/tools/popPageManager';
import {
  doAllinpayAuth,
  getAllinpayPopInstance,
} from '@/views_v2/apply-product/components/rights/bind-card-pop/show';
import { rightsManager } from '@/widgets/loan-right/RightsManager';
import { shouldShowPartialLoanTipForQuick } from '@/views_v2/apply-product/utils/partial-loan';
import DiscountItem from './components/discount-item/index.vue';
import AmountDisplay from './components/amount-display/index.vue';
import RepaymentInfo from './components/repayment-info/index.vue';
import BankCardInfo from './components/bank-card-info/index.vue';
import OtherInfo from './components/other-info/index.vue';
import SuperCard from './components/super-card/index.vue';
import { useQuickWithdrawData } from './hooks/useQuickWithdrawData';

import {
  TP_QUICK_WITHDRAW_CARD_CLOSE,
  TP_QUICK_WITHDRAW_CARD_OTHER_AMOUNT,
  TP_QUICK_WITHDRAW_CARD_REPAYMENT_TRAIL,
  TP_QUICK_WITHDRAW_CARD_SHOW,
  TP_QUICK_WITHDRAW_CARD_SUBMIT,
} from './tianqi';
import { quickWithdrawCardUtils } from './utils';

// 异步引入 FinanceReplan 组件
const FinanceReplan = defineAsyncComponent(() => import('@/components/finance-replan/index.vue'));
const ForceAgreementView = defineAsyncComponent(() => import('./components/force-agreement-view/index.vue'));

const SMSDialog = defineAsyncComponent(() => import('@/components/smsDailog'));

/** 权益卡片组件 */
const RightCard = defineAsyncComponent(() => import('@/widgets/loan-right/index.vue'));

interface Props {
  userCreditData: CreditDataType; // 用户授信数据
}

export default defineComponent({
  name: 'QuickWithdrawCard',
  components: {
    Popup,
    Button,
    DiscountItem,
    AmountDisplay,
    RepaymentInfo,
    BankCardInfo,
    OtherInfo,
    FinanceReplan,
    SuperCard,
    ForceAgreementView,
    CloseOutline,
    SMSDialog,
    RightCard,
  },
  props: {
    // 移除 visible prop
    userCreditData: {
      type: Object as () => CreditDataType,
      default: () => ({}),
      required: true,
    },
  },
  setup(props: Props) {
    // 使用数据管理Hook
    const {
      pageData,
      selectedCoupon,
      formattedAmount,
      formattedRepaymentInfo,
      shouldShowSuperMember,
      initializePageData,
      refreshPageData,
      fetchContracts,
      selectCoupon,
      cancelCoupon,
      selectLoanPurpose,
      submitOrderWithLiveness,
      validateSubmitData,
      checkPrivacyAgreement,
      handleSubmitSmsCode,
      hideSmsDialog,
      handleRightTabChange,
      hideTradeKeyDialog,
      isTradeKeyDialogOpen,
    } = useQuickWithdrawData(props.userCreditData);

    // 直接使用 FinanceBusiness mixin 中的方法
    const financeBusiness = new FinanceBusiness();

    // 使用 mixin 中的 checkOuterChannel 方法
    const checkOuterChannel = (financeBusiness as any).checkOuterChannel.bind(financeBusiness);

    // 还款计划弹窗相关状态
    const showReplan = ref(false);
    const repayDialogData = ref<RepayDialogDataType>();

    // 协议弹窗相关状态
    const showForceAgreement = ref(false);
    const curIndex = ref(0);
    const currentAgreementIndex = ref(0);

    // 计算属性：基于协议数据生成机构列表
    const contractData = computed(() => pageData.contracts);

    // 计算属性：当前选中的协议列表（转换为协议弹窗组件需要的格式）
    const curContractList = computed(() => contractData.value[curIndex.value]?.contractList || []);

    // 数据刷新状态管理
    const isDataInitialized = ref(false);
    const isRefreshing = ref(false);
    const lastRefreshTime = ref<number>(0);

    // 防重状态管理
    const lastClickTime = ref({
      submit: 0,
      otherBtn: 0,
      agreementConfirm: 0,
    });


    // 容器引用和高度
    const containerRef = ref<HTMLElement>();
    const containerHeight = ref<number>(0);

    // top 区域引用和固定标题显示状态
    const topRef = ref<HTMLElement>();
    const showFixedTitle = ref(false);

    // SuperCard 组件引用
    const superCardRef = ref<any>(null);

    // 本地显示状态，用于控制组件的显示/隐藏
    const isVisible = ref(false);

    // 处理关闭弹窗
    const handleClose = () => {
      // 只设置本地显示状态为 false，不修改接口返回的数据
      ubtSetupPageButton(TP_QUICK_WITHDRAW_CARD_CLOSE);
      isVisible.value = false;
    };

    // 监听 pageData.config?.quickLoan 的变化，同步更新 isVisible
    // 但只有在用户没有主动关闭的情况下才同步
    watch(
      () => pageData.config?.quickLoan,
      (newValue) => {
        // 如果接口返回 true，且用户没有主动关闭，则显示
        if (newValue) {
          ubtSetupModuleExpose(TP_QUICK_WITHDRAW_CARD_SHOW, {
            amount: formattedAmount.value,
          });
          /** 如果接口返回 true，显示，需要调用疲劳度接口上报 */
          isVisible.value = true;
          reportQuickPopShow();
        } else {
          // 如果接口返回 false，则隐藏（但不会覆盖用户主动关闭的状态）
          handleClose();
        }
      },
      { immediate: true },
    );

    // 计算属性：借款机构名称, 单通道 支持 自营和轻资产渠道名称获取逻辑
    const institutionName = computed(() => {
      const { capitalList, productName } = pageData.config?.quickLoanChannel || {};
      const capitalName = capitalList?.length && capitalList.length > 0 ? capitalList?.[0]?.capitalName || '' : productName || '';
      const routeMarket = capitalList?.length && capitalList.length > 0 ? capitalList?.[0]?.routeMarket : '';
      // 如果是串行模式，需要在机构名称后面加上 '等'
      if (routeMarket === RouteMarketEnum.SERIAL) {
        return capitalName ? `${capitalName}等` : '';
      }
      return capitalName;
    });

    // 计算属性：产品ID
    const productId = computed(() => pageData.config?.quickLoanChannel?.productId || '');

    // 计算属性：是否支持部分放款成功
    const loanPartTag = computed(
      () => shouldShowPartialLoanTipForQuick(pageData.config?.quickLoanChannel),
    );


    // 获取容器高度的方法
    const updateContainerHeight = async () => {
      await nextTick();
      if (containerRef.value) {
        const maxContainerHeight = window.innerHeight * 0.7;
        containerHeight.value = Math.min(containerRef.value.offsetHeight, maxContainerHeight);
      }
    };

    /** 钱包tab 和容器化不挂载组件 */
    const shouldMountComponent = async (): Promise<boolean> => {
      const isInTabbarContainer = await skNativeContainer();
      const isInWalletTab = store.state.base.isHybridAppMode;

      const shouldNotMount = isInTabbarContainer || isInWalletTab;

      return !shouldNotMount;
    };

    // 数据刷新逻辑
    const refreshData = async (forceRefresh = false) => {
      // 非helloapp不进行数据刷新
      if (!platform.isHelloApp) {
        return;
      }
      // 防止重复刷新
      if (isRefreshing.value) {
        return;
      }

      // 如果不是强制刷新，检查是否需要刷新（避免过于频繁的请求）
      const now = Date.now();
      if (!forceRefresh && isDataInitialized.value && (now - lastRefreshTime.value) < 5000) {
        return;
      }

      isRefreshing.value = true;
      lastRefreshTime.value = now;

      try {
        // 使用Hook中的刷新方法，只刷新关键数据
        await refreshPageData();

        // 数据加载完成后更新容器高度
        await updateContainerHeight();

        isDataInitialized.value = true;
      } catch (error) {
        // 刷新失败，静默处理
      } finally {
        isRefreshing.value = false;
      }
    };


    // 滚动事件处理：当内容上滑时显示固定标题
    const handleTopScroll = () => {
      if (topRef.value) {
        // 当滚动距离大于 0 时显示固定标题
        showFixedTitle.value = topRef.value.scrollTop > 0;
      }
    };

    // 监听 isVisible 变化，在弹窗显示时注册滚动事件监听
    watch(isVisible, (newValue) => {
      if (newValue) {
        // 弹窗显示时，等待 DOM 更新后注册滚动监听
        nextTick(() => {
          if (topRef.value) {
            topRef.value.addEventListener('scroll', handleTopScroll);
          }
        });
      } else {
        // 弹窗隐藏时，移除滚动监听
        if (topRef.value) {
          topRef.value.removeEventListener('scroll', handleTopScroll);
        }
      }
    });

    // 组件挂载时初始化数据
    onMounted(async () => {
      // 检查是否应该挂载组件
      if (!(await shouldMountComponent())) {
        return;
      }

      /** 监听app容器切换 */
      listerBack(async () => {
        // 只有在数据已经初始化过的情况下才进行刷新
        if (isDataInitialized.value) {
          await refreshData();
        }
      }, false);

      try {
        await initializePageData();

        // 数据加载完成后更新容器高度
        await updateContainerHeight();
        isDataInitialized.value = true;
      } catch (error) {
        // 初始化失败，静默处理
      }
    });

    // 组件卸载时移除滚动事件监听
    onBeforeUnmount(() => {
      if (topRef.value) {
        topRef.value.removeEventListener('scroll', handleTopScroll);
      }
    });

    // keep-alive组件激活时的数据刷新
    onActivated(async () => {
      // 检查是否应该激活组件
      if (!(await shouldMountComponent())) {
        return;
      }

      // 只有在数据已经初始化过的情况下才进行刷新
      if (isDataInitialized.value) {
        await refreshData();
      }
    });

    // 跳转到银行卡选择页面的方法
    const navigateToCardList = async () => {
      const commodityId = pageData.config?.quickLoanChannel?.productId || '';
      const capitalCode = pageData.capitalCode || '';

      if (platform.isHelloApp) {
        // 通过新WebView打开银行卡选择页面
        const cardListUrl = `${financeH5WebUrl}#${RouterV2Enum.cardList}?from=${FormInfomation.QuickWithdraw}&commodityId=${commodityId}&capitalCode=${capitalCode}`;
        await openThirdPage(cardListUrl);
      } else {
        // 跳转到银行卡选择页面
        router.push({
          path: RouterV2Enum.cardList,
          query: {
            from: FormInfomation.QuickWithdraw,
            commodityId,
            capitalCode,
          },
        });
      }
    };

    // 处理提交
    const handleSubmit = async () => {
      // 防重：200ms内只执行一次
      const now = Date.now();
      const lastTime = lastClickTime.value.submit;
      if (lastTime > 0 && now - lastTime < 200) {
        return;
      }
      lastClickTime.value.submit = now;

      try {
        ubtSetupPageButton(TP_QUICK_WITHDRAW_CARD_SUBMIT, {
          amount: pageData.config?.quickLoanChannel?.availableAmount || 0,
          period: pageData.billCalc?.loanCalcList?.length || 0,
          capitalCode: pageData.capitalCode || '',
          loanPurpose: pageData.selectedLoanPurpose?.code || '',
          couponId: selectedCoupon.value?.couponId || '',
          bankCode: pageData.bankCardInfo?.bankNo || '',
          bankCard: pageData.bankCardInfo?.userBankCardId || '',
          productId: pageData.config?.quickLoanChannel?.productId || '',
        });

        // TOOD: 这里建议优化成validatePromise, 这样可以清晰知道做了哪些逻辑校验
        // 隐私授权协议校验 - 前置到最前面
        const agreementPassed = await checkPrivacyAgreement();
        if (!agreementPassed) {
          return;
        }

        // 先进行数据验证--表单项是否填写完整校验--toast提示
        const validation = validateSubmitData();
        if (!validation.isValid) {
          // 只显示第一个错误，避免消息过长
          Toast(validation.errors[0] || '提交数据验证失败');
          return;
        }

        /** 校验权益卡片是否勾选- 如果未勾选，则中断提现流程 */
        if (!(await rightsManager.validate())) {
          return;
        }

        // 检查银行卡信息是否存在
        if (!pageData.bankCardInfo?.userBankCardId) {
          // 银行卡信息不存在，先校验资料完整度，完整后再跳转到卡选择页面
          // 校验用户资料完整度
          try {
            await checkOuterChannel({
              commodityIds: [pageData.config?.quickLoanChannel?.productId || ''],
            });
          } catch (error) {
            Toast('资料信息不完整，请先完善资料');
            return;
          }
          /** 因为popupview 用的原生导航栏，所以需要关闭 */
          setNativeNavBar(false);
          // 使用抽离的跳转方法
          await navigateToCardList();
          return;
        }

        /** s2002事件检测，中断提现流程 */
        try {
          await loanOrderCheck({ productId: pageData.config?.quickLoanChannel?.productId || '' });
        } catch (error) {
          const errCode = Number((error as { code: string }).code || 0);

          /** 若是渠道检测不准入，则中断提现流程 */
          if (errCode === ResponseCodeEnum.LOAN_ORDER_CHECK_REJECT) {
            return;
          }
        }

        /** 通联权益绑卡校验 */
        const allinpayAuthCheckRes = await doAllinpayAuth({
          productId: productId.value,
          /** 权益数据获取，通过getData获取 */
          tqParams: {
            capitalCode: pageData.capitalCode,
            packageType: pageData.config?.quickLoanChannel?.capitalList?.[0]?.packageType
            || undefined,
          },
          bankCardId: pageData.bankCardInfo?.userBankCardId || '',
          equityTick: pageData.superCardSelected
          || rightsManager.context.value.checkStatus || false,
          // 直接取试算中返回的定价类型
          pricingType: pageData.billCalc?.pricingType,
        });

        /** 通联绑卡校验通过，继续执行下方操作 */
        if (!allinpayAuthCheckRes) {
          return;
        }

        /** 获取提现协议 */
        await fetchContracts();

        /** 协议数据获取成功，展示提现协议弹窗，让用户确认协议 */
        showForceAgreement.value = true;
      } catch (error) {
        ubtSendError(error instanceof Error ? error : new Error(`handleSubmit error: ${String(error)}`));
      }
    };

    // 处理优惠券选择
    const handleCouponSelect = (coupon: CouponRolePo, index: number, isAvailable: boolean) => {
      if (isAvailable) {
        selectCoupon(coupon);
      }
    };

    // 处理不选择优惠券
    const handleNoCoupon = () => {
      cancelCoupon();
    };

    // 构建还款计划弹窗数据的辅助函数
    const buildRepayDialogData = (billCalc: any) => {
      // 参考 apply-product 的实现，使用展开运算符保留原有数据
      const { repaymentModel = [], calcMethod } = pageData.productInfo?.productInfo || {};
      const routeMarket = pageData.config?.quickLoanChannel?.capitalList?.[0]?.routeMarket;

      return {
        // 展开试算数据，保留所有原有字段
        ...billCalc,

        // 添加产品相关信息
        routeMarket,
        calcMethod,
        repaymentModel,

        // 确保必要字段有默认值
        lender: pageData.productInfo?.productInfo?.productName || '',
        calcResult: billCalc.calcResult || 'SUCCESS',
        calcMsg: billCalc.calcMsg || '',
        userCalcMsg: billCalc.userCalcMsg || '',
      };
    };

    // 处理还款信息点击
    const handleRepaymentClick = async () => {
      // 检查试算数据是否存在
      if (!pageData.billCalc || !pageData.billCalc?.loanCalcList?.length) {
        return;
      }

      // 在显示弹窗前更新容器高度
      await updateContainerHeight();

      // 构建还款计划弹窗数据
      repayDialogData.value = buildRepayDialogData(pageData.billCalc);
      showReplan.value = true;
      ubtSetupModuleExpose(TP_QUICK_WITHDRAW_CARD_REPAYMENT_TRAIL);
    };

    // 处理借款用途更新
    const handleLoanPurposeUpdate = (purpose: any) => {
      selectLoanPurpose(purpose);
    };

    // 处理超级会员协议选择状态变化
    const handleSuperCardAgreementChange = (checked: boolean) => {
      // 更新超级会员选择状态，用于后续提交订单时判断
      pageData.superCardSelected = checked;
    };

    // 处理其他按钮点击
    const handleOtherBtnClick = () => {
      // 防重：200ms内只执行一次
      const now = Date.now();
      const lastTime = lastClickTime.value.otherBtn;
      if (lastTime > 0 && now - lastTime < 200) {
        return;
      }
      lastClickTime.value.otherBtn = now;

      ubtSetupPageButton(TP_QUICK_WITHDRAW_CARD_OTHER_AMOUNT);
      /** 关闭主弹窗，避免用户重复点击其他按钮 */
      handleClose();

      // 跳转到提现页面
      router.push({
        path: RouterV2Enum.applyProduct,
        query: {
          commodityId: pageData.config?.quickLoanChannel?.productId || '',
          from: 'quickWithdrawCard',
        },
      });
    };

    // 关闭还款计划弹窗
    const handleCloseReplan = () => {
      showReplan.value = false;
    };

    // 移除 AuthDialog 的方法
    const removeAuthDialog = (): boolean => {
      // 查找 DOM 中是否存在 AuthDialog 元素
      const authDialogElement = document.querySelector('.AuthDialog');
      if (authDialogElement) {
        // 向上查找 Vue 组件实例的根元素（通常是直接包含在 body 中的元素）
        let elementToRemove: Element | null = authDialogElement;
        while (elementToRemove && elementToRemove.parentElement) {
          const parent: HTMLElement = elementToRemove.parentElement;
          // 如果父元素是 body，说明找到了组件根元素
          if (parent === document.body) {
            document.body.removeChild(elementToRemove);
            break;
          }
          elementToRemove = parent;
        }
        return true;
      }
      return false;
    };

    // 协议弹窗相关方法
    const changeInstitution = (index: number) => {
      curIndex.value = index;
      currentAgreementIndex.value = 0;
    };

    const changeAgreementIndex = (index: number) => {
      currentAgreementIndex.value = index;
    };

    const handleAgreementConfirm = async () => {
      // 防重：200ms内只执行一次
      const now = Date.now();
      const lastTime = lastClickTime.value.agreementConfirm;
      if (lastTime > 0 && now - lastTime < 200) {
        return;
      }
      lastClickTime.value.agreementConfirm = now;

      // 用户确认协议后的处理逻辑
      showForceAgreement.value = false;
      try {
        // 再次校验资料填写完整度
        try {
          await checkOuterChannel({
            commodityIds: [pageData.config?.quickLoanChannel?.productId || ''],
          });
        } catch (error) {
          Toast('资料信息不完整，请先完善资料');
          return;
        }


        // 提现是否需要补充资料校验
        const fields = await supplyNeedConfig([pageData.config?.quickLoanChannel?.productId || ''], SceneTypeEnum.LOAN);
        const supplyValidFields = fields.filter((name) => name !== 'id');
        /** 需要补充资料 */
        if (supplyValidFields && supplyValidFields.length) {
          // 其他情况用补充资料组件
          jumpToVerifyCredit(VerifySceneEnum.LOAN_SUPPLY_PERSONAL, {
            commodityIds: [pageData.config?.quickLoanChannel?.productId || ''],
            useReplace: true,
            openMode: OpenVerifyPageMode.POPUP_SHOW,
            successCb: async () => {
              /** 因为popupview 用的原生导航栏，所以需要关闭 */
              setNativeNavBar(false);
              // 提交订单
              submitOrderWithLiveness();
            },
          });
        } else {
          // 提交订单
          submitOrderWithLiveness();
        }
      } catch (error) {
        ubtSendError(error instanceof Error ? error : new Error(`handleAgreementConfirm error: ${String(error)}`));
      }
    };

    return {
      // 数据状态
      pageData,
      selectedCoupon,
      showReplan,
      repayDialogData,

      // 协议弹窗相关
      showForceAgreement,
      curIndex,
      currentAgreementIndex,
      contractData,
      curContractList,
      isVisible,

      // 数据刷新状态
      isDataInitialized,
      isRefreshing,

      // 计算属性
      institutionName,
      productId,
      formattedAmount,
      formattedRepaymentInfo,
      loanPartTag,

      // 容器相关
      containerRef,
      containerHeight,
      topRef,
      showFixedTitle,

      // 方法
      handleClose,
      handleSubmit,
      handleCouponSelect,
      handleNoCoupon,
      handleRepaymentClick,
      handleLoanPurposeUpdate,
      handleOtherBtnClick,
      handleCloseReplan,
      navigateToCardList,
      handleRightTabChange,
      updateContainerHeight,
      // 协议弹窗方法
      changeInstitution,
      changeAgreementIndex,
      handleAgreementConfirm,
      handleSuperCardAgreementChange,

      // 数据刷新方法
      refreshData,
      shouldShowSuperMember,
      superCardRef,
      hideSmsDialog,
      handleSubmitSmsCode,
      quickWithdrawCardUtils,
      // 暴露给父组件的方法：关闭弹窗 返回true ，弹窗不存在或者未关闭 返回false
      closePopup: async () => {
        // eslint-disable-next-line no-console
        console.error('closePopup');
        //  当超级会员协议存在的时候，清理 SuperCard 超级会员协议组件实例
        /**  TODO: 这里待优化成判断弹窗协议展示的时候 再调用 */
        if (superCardRef.value && typeof superCardRef.value.destroyInstance === 'function') {
          // eslint-disable-next-line no-console
          console.error('超级会员协议弹窗存在-需要关闭弹窗');
          superCardRef.value.destroyInstance();
          // eslint-disable-next-line no-console
          console.error('超级会员协议弹窗关闭成功');
        }

        // 如果 DOM 上存在 AuthDialog，则移除
        if (removeAuthDialog()) {
          // eslint-disable-next-line no-console
          console.error('AuthDialog弹窗存在-需要关闭弹窗');
          // eslint-disable-next-line no-console
          console.error('AuthDialog弹窗关闭成功');
          return true;
        }

        /** 交易密码弹窗存在-需要关闭弹窗 */
        if (isTradeKeyDialogOpen()) {
          // eslint-disable-next-line no-console
          console.error('交易密码弹窗存在-需要关闭弹窗');
          hideTradeKeyDialog();
          // eslint-disable-next-line no-console
          console.error('交易密码弹窗关闭成功');
          return true;
        }

        /** 短信验证码弹窗存在- 需要关闭弹窗 */
        if (pageData.showSmsCode) {
          // eslint-disable-next-line no-console
          console.error('短信验证码弹窗存在-需要关闭弹窗');
          hideSmsDialog();
          // eslint-disable-next-line no-console
          console.error('短信验证码弹窗关闭成功');
          return true;
        }

        /** 通联权益绑卡弹窗存在- 需要关闭弹窗 */

        if ((await getAllinpayPopInstance())?.$props.visible) {
          // eslint-disable-next-line no-console
          console.error('通联权益绑卡弹窗存在-需要关闭弹窗');
          (await getAllinpayPopInstance()).$destroy();
          // eslint-disable-next-line no-console
          console.error('通联权益绑卡弹窗关闭成功');
          return true;
        }

        /** 权益协议弹窗存在 -需要关闭弹窗 */
        if ((await rightsManager.getData()).status.contractShow) {
          // eslint-disable-next-line no-console
          console.error('权益协议弹窗存在-需要关闭弹窗');
          rightsManager.destroyInstance();
          // eslint-disable-next-line no-console
          console.error('权益协议弹窗关闭成功');
          return true;
        }

        /** 权益详情存在 - 需要关闭弹窗 */
        if ((await rightsManager.getData()).status.detailShow) {
          // eslint-disable-next-line no-console
          console.error('权益详情弹窗存在-需要关闭弹窗');
          rightsManager.destroyInstance();
          // eslint-disable-next-line no-console
          console.error('权益详情弹窗关闭成功');
          return true;
        }

        // 如果存在 popup 弹窗（popPageManager）
        if (popPageManager.hasOpenedPopPage()) {
          // eslint-disable-next-line no-console
          console.error('popup 弹窗存在-需要关闭弹窗');
          popPageManager.saveOrCloseOpendPop();
          // eslint-disable-next-line no-console
          console.error('popup 弹窗关闭成功');
          return true;
        }
        // 如果存在 popup--ocr 活体 补充资料这些 弹窗（PopupView）
        if (PopupView.instance && PopupView.instance.visible) {
          // eslint-disable-next-line no-console
          console.error('popupview 弹窗存在-需要关闭弹窗');
          PopupView.close();
          /** 因为popupview 用的原生导航栏，所以需要关闭 */
          setNativeNavBar(false);
          // eslint-disable-next-line no-console
          console.error('popupview 弹窗关闭成功');
          return true;
        }
        // 如果主弹窗显示，则关闭主弹窗
        if (isVisible.value) {
          // eslint-disable-next-line no-console
          console.error('主弹窗存在-需要关闭弹窗');
          handleClose();
          // eslint-disable-next-line no-console
          console.error('主弹窗关闭成功');
          return true;
        }
        // eslint-disable-next-line no-console
        console.error('所有弹窗关闭成功');
        return false;
      },
    };
  },
});
